(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ycn-booking-attribution"] && !Shopify.designMode) return;
  try {
    (() => {
  if(window.ycnBookingAttribution)return;
  const fields={utm_source:'YCN UTM Source',utm_medium:'YCN UTM Medium',utm_campaign:'YCN UTM Campaign',utm_content:'YCN UTM Content',meta_campaign_id:'YCN Meta Campaign ID',meta_ad_id:'YCN Meta Ad ID'};
  let queue=Promise.resolve(),context={};
  const allowed=()=>{
    const privacy=window.Shopify?.customerPrivacy;
    try{return {analytics:privacy?.analyticsProcessingAllowed()===true,marketing:privacy?.marketingAllowed()===true};}catch{return {analytics:false,marketing:false};}
  };
  const gaId=()=>new Promise(resolve=>{
    let done=false;
    const finish=value=>{if(!done){done=true;resolve(typeof value==='string'&&/^\d{1,20}\.\d{1,20}$/.test(value)?value:'');}};
    setTimeout(()=>finish(''),1500);
    try{if(allowed().analytics&&typeof window.gtag==='function')window.gtag('get','G-3S0HWCYXJM','client_id',finish);else finish('');}catch{finish('');}
  });
  const sync=async bookingId=>{
    const root=window.Shopify?.routes?.root||'/';
    const response=await fetch(root+'cart.js',{credentials:'same-origin',signal:AbortSignal.timeout(5000)});
    if(!response.ok)throw Error('Cart unavailable');
    const cart=await response.json(),previous=cart.attributes||{},attributes={};
    const client=await gaId(),consent=allowed(),params=new URLSearchParams(location.search);
    attributes['YCN Analytics Consent']=consent.analytics?'true':'false';
    attributes['YCN GA Client ID']=consent.analytics?client:'';
    context={};
    for(const [key,attribute] of Object.entries(fields)){
      const urlKey=key==='meta_campaign_id'?'campaign_id':key==='meta_ad_id'?'ad_id':key;
      const value=params.get(urlKey)||(params.has('utm_campaign')?'':previous[attribute])||'';
      const valid=key.startsWith('meta_')?/^\d{1,30}$/.test(value):/^[A-Za-z0-9_. -]{1,120}$/.test(value);
      attributes[attribute]=consent.marketing&&valid?value:'';
      if(attributes[attribute])context[key]=attributes[attribute];
    }
    if(typeof bookingId==='string'&&/^quote:[0-9a-f-]{36}$/.test(bookingId))attributes['YCN Booking ID']=bookingId;
    const changes=Object.fromEntries(Object.entries(attributes).filter(([key,value])=>(previous[key]||'')!==value));
    if(Object.keys(changes).length){
      const updated=await fetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:changes}),signal:AbortSignal.timeout(5000)});
      if(!updated.ok)throw Error('Cart update unavailable');
    }
    return {...context};
  };
  const run=bookingId=>{queue=queue.catch(()=>{}).then(()=>sync(bookingId));return queue;};
  window.ycnBookingAttribution={read:()=>run(),saveQuote:bookingId=>run(bookingId)};
  const refresh=()=>{run().catch(()=>{});};
  document.addEventListener('visitorConsentCollected',refresh);
  if(!window.Shopify?.customerPrivacy&&typeof window.Shopify?.loadFeatures==='function')window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],refresh);
  else refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ycn-quote-analytics"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!/\/pages\/quote\/?$/.test(location.pathname) || window.__ycnQuoteAnalyticsInstalled) return;
  window.__ycnQuoteAnalyticsInstalled = true;
  const observed = new WeakSet();
  const formSelector = '[data-forms-id="forms-root-1160849"] shopify-forms-embed';
  const emit = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (privacy?.analyticsProcessingAllowed() !== true || typeof window.gtag !== 'function') return;
      const params = {
        send_to: 'G-3S0HWCYXJM',
        form_id: '1160849',
        lead_source: 'shopify_forms',
        page_location: location.origin + location.pathname
      };
      if (privacy.marketingAllowed() === true) {
        const query = new URLSearchParams(location.search);
        for (const [queryKey, eventKey] of [['campaign_id', 'lead_campaign_id'], ['ad_id', 'lead_ad_id']]) {
          const value = query.get(queryKey);
          if (value && /^\d{1,30}$/.test(value)) params[eventKey] = value;
        }
      }
      window.gtag('event', 'conversion_event_submit_lead_form', params);
    } catch (_) {}
  };
  const attach = () => {
    document.querySelectorAll(formSelector).forEach(host => {
      const root = host.shadowRoot;
      if (!root || observed.has(root)) return;
      observed.add(root);
      let sawForm = false;
      let handled = false;
      const check = () => {
        if (handled) return;
        if (root.querySelector('form')) sawForm = true;
        if (sawForm && root.querySelector('[data-testid="banner-success"]')) {
          handled = true;
          emit();
          observer.disconnect();
        }
      };
      const observer = new MutationObserver(check);
      observer.observe(root, { childList: true, subtree: true });
      check();
    });
  };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  const watch = new MutationObserver(attach);
  watch.observe(document.documentElement, { childList: true, subtree: true });
  attach();
  let attempts = 0;
  const timer = setInterval(() => {
    attach();
    if (++attempts >= 60) clearInterval(timer);
  }, 1000);
  window.addEventListener('pagehide', () => {
    clearInterval(timer);
    watch.disconnect();
  }, { once: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ycn-seo-measurement"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__ycnSeoMeasurementInstalled) return;
  window.__ycnSeoMeasurementInstalled = true;
  const key = 'ycn_seo_origin';
  const preview = (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') || window.Shopify?.designMode === true || new URLSearchParams(location.search).has('preview_theme_id') || document.getElementById('preview-bar-iframe') !== null;
  const allowed = () => {
    try { return !preview && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  };
  const node = document.getElementById('ycn-seo-context');
  let context = null;
  let viewed = false;
  try { context = node ? JSON.parse(node.textContent) : null; } catch {}
  const emit = (name, params = {}) => {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    try {
      window.gtag('event', name, {send_to:'G-3S0HWCYXJM',page_location:location.origin + location.pathname,...params});
      return true;
    } catch { return false; }
  };
  const refresh = () => {
    if (!allowed()) {
      try { sessionStorage.removeItem(key); } catch {}
      return;
    }
    if (!context) return;
    try { sessionStorage.setItem(key, JSON.stringify(context)); } catch {}
    if (!viewed) viewed = emit('ycn_seo_landing_view', {seo_page_handle:context.handle,seo_page_title:context.title,seo_cluster:context.cluster,seo_intent:context.intent});
  };
  document.addEventListener('visitorConsentCollected', refresh);
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], refresh);
  } else refresh();
  document.addEventListener('click', event => {
    const link = event.target?.closest?.('a[href]');
    if (!link) return;
    let url;
    try { url = new URL(link.href, location.origin); } catch { return; }
    const base = context ? {seo_page_handle:context.handle,seo_cluster:context.cluster} : {};
    if (url.protocol === 'tel:') { emit('ycn_phone_click', base); return; }
    if (url.protocol === 'https:' && ['wa.me','api.whatsapp.com','web.whatsapp.com'].includes(url.hostname)) { emit('ycn_whatsapp_click', base); return; }
    if (!context || url.origin !== location.origin) return;
    base.link_url = url.pathname;
    if (url.pathname.replace(/\/$/, '') === '/pages/quote') { emit('ycn_seo_quote_intent', base); return; }
    if (url.pathname.startsWith('/products/')) { emit('ycn_seo_yacht_click', base); return; }
    if (url.pathname.startsWith('/pages/') && url.pathname !== location.pathname) emit('ycn_seo_internal_click', base);
  }, {passive:true});
  window.ycnSeoMeasurement = {
    origin: () => {
      if (!allowed()) return null;
      try {
        const value = JSON.parse(sessionStorage.getItem(key) || 'null');
        return value && /^[a-z0-9-]{1,160}$/.test(value.handle) ? value : null;
      } catch { return null; }
    }
  };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ycn-term-charter-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ycn-term-charter')) {
  customElements.define('ycn-term-charter', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.q = (selector) => this.querySelector(selector);

      this.fleetSelect = this.q('[data-yacht]');
      if (this.fleetSelect) {
        this.fleet = new Map(Array.from(this.querySelectorAll('[data-fleet-product]'), node => [node.dataset.fleetProduct, JSON.parse(node.textContent)]));
        this.q('[data-price]').removeAttribute('min');
        this.q('[data-price]').removeAttribute('max');
        this.q('[data-departure]').disabled = true;
        this.fleetSelect.addEventListener('change', () => this.selectYacht());
      }
      this.addEventListener('input', () => this.update());
      this.addEventListener('change', () => this.update());
      this.update();
    }
    duration(variant) {
      const label = (variant.options?.[0] || variant.title.split(' / ')[0]).trim().toLowerCase();
      return label === '24 hours' ? 1 : label === '1 week' ? 7 : 0;
    }
    location(variant) {
      return variant.options?.[1] || variant.title.split(' / ').slice(1).join(' / ');
    }
    selectYacht() {
      const photo = this.q('[data-yacht-photo]');
      const image = Array.from(this.querySelectorAll('[data-yacht-image]')).find(node => node.dataset.yachtImage === this.fleetSelect.value);
      photo.replaceChildren();
      photo.hidden = !image;
      if (image) photo.append(image.content.cloneNode(true));
      const pickup = this.q('[data-pickup]');
      const variants = this.fleet.get(this.fleetSelect.value) || [];
      const currentDays = Number(this.q('[data-days]').value);
      const eligible = variants.filter(v => this.duration(v));
      const preferred = eligible.find(v => this.duration(v) === (currentDays === 7 ? 7 : 1));
      pickup.replaceChildren();
      for (const location of new Set(eligible.map(v => this.location(v)))) pickup.add(new Option(location, location));
      if (preferred) pickup.value = this.location(preferred);
      pickup.disabled = !eligible.length;
      this.update();
    }
    applyFleet(days) {
      const note = this.q('[data-rate-note]');
      const variants = this.fleet.get(this.fleetSelect.value) || [];
      const pickup = this.q('[data-pickup]').value;
      const variant = variants.find(v => this.duration(v) === (days === 7 ? 7 : 1) && this.location(v) === pickup);
      const defaultVariant = variants.find(v => this.duration(v) === 1);
      const validRate = Boolean(variant && (days === 7 || days === 1 || defaultVariant));
      const base = validRate ? (days === 7 ? variant.price : variant.price + (days - 1) * defaultVariant.price) : 0;
      const tax = /nassau|bimini|bahamas/i.test(pickup) ? '14' : '7';
      this.q('[data-departure]').value = tax;
      this.fleetBase = base;
      this.q('[data-price]').value = validRate ? String(Math.round(base / 100)) : '';
      const money = new Intl.NumberFormat('en-US', {style:'currency',currency:this.dataset.currency || 'USD',minimumFractionDigits:0,maximumFractionDigits:0});
      if (!validRate) {
        note.textContent = this.fleetSelect.value ? note.dataset.missing : note.dataset.choose;
      } else if (days === 7) {
        note.textContent = `${note.dataset.weekly}: ${money.format(variant.price / 100)}`;
      } else {
        note.textContent = `${note.dataset.daily}: ${money.format(variant.price / 100)} (${pickup})`;
        if (days > 1) note.textContent += ` + ${note.dataset.remaining}: ${money.format(defaultVariant.price / 100)} × ${days - 1} (${this.location(defaultVariant)}) = ${money.format(base / 100)}`;
      }
      this.q('[data-invalid]').textContent = note.textContent;
      return validRate;
    }
    updateContactLinks(days, valid, estimate) {
      const quote = this.q('[data-quote-link]');
      const whatsapp = this.q('[data-whatsapp-link]');
      if (!quote || !whatsapp) return;
      this.quotePath ||= quote.getAttribute('href');
      const url = new URL(this.quotePath, window.location.origin);
      const currency = this.dataset.currency || 'USD';
      const selected = this.fleetSelect?.selectedOptions[0];
      const yacht = this.fleetSelect?.value || '';
      const name = yacht ? selected.textContent.trim() : '';
      const marina = this.q('[data-pickup]')?.value || '';
      const data = {version:1,days,currency,pickup_marina:marina,estimate_available:valid,...estimate};
      url.searchParams.set('charter_origin', 'term-charter-calculator');
      url.searchParams.set('available_days', String(days));
      if (yacht) {
        url.searchParams.set('yacht', yacht);
        url.searchParams.set('yacht_name', name);
        url.searchParams.set('yacht_handle', selected.dataset.handle || '');
      }
      if (marina) url.searchParams.set('charter_destination', marina);
      url.searchParams.set('term_charter', JSON.stringify(data));
      quote.href = url.toString();
      const money = new Intl.NumberFormat('en-US', {style:'currency',currency,maximumFractionDigits:0});
      const message = ['Hello YCN, I would like a personalized term charter quote.', name && `Yacht: ${name}`, `Duration: ${days} ${days === 1 ? 'day' : 'days'}`, marina && `Pickup marina: ${marina}`, valid && `Boat & crew: ${money.format(estimate.boat_crew_cents / 100)} ${currency}`, valid && `Estimated total: ${money.format(estimate.total_cents / 100)} ${currency} (including tax, 35% APA and ${estimate.gratuity_rate}% gratuity)`, !valid && 'Please confirm pricing and availability.'].filter(Boolean).join('\n');
      whatsapp.href = `https://wa.me/18186404505?text=${encodeURIComponent(message)}`;
    }
    update() {
      const priceInput = this.q('[data-price]');
      const days = Number(this.q('[data-days]').value);
      const fleetValid = this.fleetSelect ? this.applyFleet(days) : true;
      const price = this.fleetSelect ? this.fleetBase / 100 : priceInput.valueAsNumber;
      const valid = fleetValid && Number.isFinite(price) && (this.fleetSelect ? price > 0 : priceInput.validity.valid && price >= 4000 && price <= 120000);
      priceInput.setAttribute('aria-invalid', String(!valid && !this.fleetSelect));
      this.q('[data-error]').hidden = Boolean(this.fleetSelect) || valid;
      this.q('[data-invalid]').hidden = valid;
      this.q('[data-results]').hidden = !valid;
      const gratuity = Number(this.q('[data-gratuity]').value);
      this.q('[data-gratuity-label]').textContent = `${gratuity}%`;
      if (!valid) { this.updateContactLinks(days, false, {}); return; }
      const base = Math.round(price * 100);
      const taxRate = Number(this.q('[data-departure]').value);
      const tax = Math.round(base * taxRate / 100);
      const apa = Math.round(base * 35 / 100);
      const tip = Math.round(base * gratuity / 100);
      const total = base + tax + apa + tip;
      this.updateContactLinks(days, true, {boat_crew_cents:base,tax_rate:taxRate,tax_cents:tax,apa_rate:35,apa_cents:apa,gratuity_rate:gratuity,gratuity_cents:tip,total_cents:total});
      const money = new Intl.NumberFormat('en-US', {style:'currency', currency:this.dataset.currency || 'USD', minimumFractionDigits:0, maximumFractionDigits:0});
      const set = (key, cents) => {this.q(`[data-${key}]`).textContent = money.format(cents / 100);};
      set('subtotal', base + tax + apa); set('base', base); set('tax', tax); set('apa', apa); set('tip', tip); set('total', total); set('per-day', Math.round(total / days));
      this.q('[data-tax-label]').textContent = `· ${taxRate}%`;
      this.q('[data-tip-label]').textContent = `· ${gratuity}%`;
      this.q('[data-duration]').textContent = days;
      const unit = this.q('[data-day-unit]');
      unit.textContent = days === 1 ? unit.dataset.singular : unit.dataset.plural;
      this.q('[data-total-range]').textContent = `${money.format((base + tax + apa + Math.round(base * .15)) / 100)} – ${money.format((base + tax + apa + Math.round(base * .20)) / 100)}`;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ycn-yacht-enquiry"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const link = event.target.closest('a');
  const primary = document.querySelector('[data-product-quote] a');
  if (!link || !primary) return;
  const url = new URL(link.href);
  if (!/\/pages\/quote\/?$/.test(url.pathname) || url.origin !== location.origin) return;
  const context = new URL(primary.href);
  for (const key of ['yacht', 'yacht_name', 'yacht_handle', 'charter_origin']) url.searchParams.set(key, context.searchParams.get(key));
  const section = primary.closest('.shopify-section');
  const values = Array.from(section.querySelectorAll('select, [aria-haspopup]')).map(field => field.value || field.textContent.trim());
  const duration = values.find(value => /^(4|6|8|24) hours$|^1 week$|^Bimini day$/i.test(value));
  if (duration) url.searchParams.set('duration', duration === '1 week' ? '1_week' : /Bimini/i.test(duration) ? '10_hrs' : duration.split(' ')[0] + '_hrs');
  const locationValue = values.find(value => value && value !== duration);
  if (locationValue) url.searchParams.set('charter_destination', locationValue);
  const date = section.querySelector('#startDate')?.value || '';
  let isoDate = date.match(/^\d{4}-\d{2}-\d{2}/)?.[0];
  if (!isoDate) {
    const visibleDate = section.querySelector('.izyDate:not([type=hidden])')?.value || '';
    const parsed = new Date(visibleDate);
    if (visibleDate && !Number.isNaN(parsed.valueOf())) isoDate = [parsed.getFullYear(), String(parsed.getMonth() + 1).padStart(2, '0'), String(parsed.getDate()).padStart(2, '0')].join('-');
  }
  if (isoDate) url.searchParams.set('start_date', isoDate);
  const guests = section.querySelector('[name="guest_count"], [name="properties[Guests]"]')?.value;
  if (guests && /^\d{1,3}$/.test(guests)) url.searchParams.set('guest_count', guests);
  link.href = url.href;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ycn-yacht-hero"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const button = event.target.closest('[data-hero-video-toggle]');
  if (!button) return;
  const video = button.closest('.ycn-panorama__hero').querySelector('video');
  if (video.paused) video.play().catch(() => {}); else video.pause();
});
const bindYachtHero = () => document.querySelectorAll('.ycn-panorama__hero video').forEach(video => {
  if (video.dataset.bound) return;
  video.dataset.bound = 'true';
  const button = video.closest('.ycn-panorama__hero').querySelector('[data-hero-video-toggle]');
  const update = () => { button.textContent = video.paused ? button.dataset.play : button.dataset.pause; button.setAttribute('aria-pressed', String(video.paused)); };
  video.addEventListener('pause', update); video.addEventListener('play', update);
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) { video.autoplay = false; video.pause(); }
  update();
});
bindYachtHero();
document.addEventListener('shopify:section:load', bindYachtHero);
  } catch(e) { console.error(e); }
})();

})();
